<template>
    <main id="mainCtrl">
        <SuccessModal ref="dialog"
                      :title="'Выгрузка ' + (M.uploadYandexFeedOn? 'включена' : 'отключена')"
                      :message="
                    'Выгрузка ваших врачей в Яндекс ' + (M.uploadYandexFeedOn? 'включена' : 'отключена') + '. Изменения<br/>' +
                    'вступят в силу после обработки данных Яндексом. <br/>' +
                    'Обычно это происходит в течение 7 дней.'"
        />
        <div v-if="clinics.length">
            <v-select
                @select="refresh"
                v-model="selectedClinicId"
                class="large network-clinics-select"
                style="max-width: 750px; margin-bottom: 15px;"
                placeholder="Выберите клинику"
                :options='clinics.map((clinic)=> {return {value: clinic.id, text: clinic.name, fullAddress: clinic.fullAddress} })'
            >
                <template v-slot="{ option }">
                    <div class="textarea">
                        <span>{{ option.text }}</span>
                        <div style="height: 8px;"/>
                        <small>{{ option.fullAddress }}</small>
                    </div>
                </template>
            </v-select>
        </div>

        <div class="promo">
            <div class="promo__data">
                <div class="promo__title">Выгрузка врачей в Яндекс</div>
                <div class="promo__markers">
                    <div class="promo__marker promo__marker_red">
                        Интеграция с Яндекс
                    </div>
                </div>
                <div class="promo__text">
                    <p>
                        Включите интеграцию с Яндекс, чтобы настроить выгрузку врачей и кнопку записи на прием через наш
                        сайт.
                    </p>
                    <ul>
                        <li>Выгрузка врачей в поиск Яндекса</li>
                        <li>Кнопка записи на прием через ДОКТУ</li>
                        <li>Автоматическое обновление информации</li>
                    </ul>
                </div>
                <div class="promo__actions">
                    <a href="#" @click="update" class="promo__btn" :class="{'promo__btn_red':M.uploadYandexFeedOn}">{{M.uploadYandexFeedOn?'Отключить':'Включить'}}</a>
                </div>
            </div>
            <div class="promo__img">
                <img src="/img/ya01.svg" alt="" />
            </div>
        </div>
    </main>
</template>

<script>
import SuccessModal from '@dialogs/SuccessModal.vue'

export default {
    components:{
        SuccessModal
    },
    props:{
        clinicId: {
            type: String,
            required: true,
        },
        clinics: {
            type: Array,
            required: true,
        },
    },
    data(){
        return{
            selectedClinicId: this.clinicId,
            M:{
                id: null,
                uploadYandexFeedOn: null,
            },
        }
    },
    mounted: function () {
        this.refresh();
    },
    methods:{
        update(){
            this.M.uploadYandexFeedOn = !this.M.uploadYandexFeedOn

            return this.axios.post('upload-yandex-feed/update', this.M).then(() => {
                this.$refs.dialog.show()
            });
        },
        refresh(){
            setTimeout( ()=> {
                let clinic = this.clinics.find((el) => el.id === this.selectedClinicId)
                if (!clinic) {
                    return;
                }
                this.M.id = clinic.id
                this.M.uploadYandexFeedOn = clinic.uploadYandexFeedOn

            }, 10)
        },
    }
}
</script>
